export class InputIconHelper {
    constructor($elem, $icon) {
        this.$elem = $elem;
        this.$icon = $icon;
        this.isPassword = $elem.is(":password");
    }
    drawValidOrResetIcon() {
        if (this.isPassword)
            return;
        let hasValue = this.$elem.val() != "";
        hasValue ? this.drawValidIcon() : this.resetIcon();
    }
    drawDeleteIcon() {
        if (this.isPassword)
            return;
        if (this.$elem.val() === '')
            return;
        this.$icon.removeClass().addClass("lar la-times-circle ax-empty-input");
    }
    resetIcon() {
        if (this.isPassword)
            return;
        this.$icon.removeClass();
        this.$icon.addClass("d-none");
    }
    drawValidIcon() {
        if (this.isPassword)
            return;
        if (this.$elem.hasClass('valid')) {
            this.$icon.removeClass();
            this.$icon.addClass("las la-check ax-color-green-500");
        }
    }
    togglePasswordIcon() {
        this.$icon.removeClass();
        this.$icon.addClass("lar la-eye");
    }
}
